import { Box, Typography } from "@mui/material";

import AllTypeOrders from "./AllTypeOrders";

const OrderList = () => {
  return (
    <Box padding={3} px={8}>
      <Typography variant="h3">Order list</Typography>
      <AllTypeOrders />
    </Box>
  );
};

export default OrderList;
